import {
  MembershipProductType,
  RoleType,
  GenderType,
  MemberAddress,
  MSSMemberStatus,
  PriceCartItem,
  MemberPhone,
  CurrentPayPlan,
  MembershipLevel,
  MaintainExistingCustomerMemberInfo,
  ExistingMemberEmail,
} from '@ace-clublabs/common-membership-api-types';

export interface MSSNotification {
  type: MSSNotificationType;
  boldText?: string;
  message?: string;
  link?: string;
  modalTitle?: string;
  modalBody?: string;
  onClick?: () => void;
  iconOverride?: string;
}

export enum MSSNotificationType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface MSSBenefitLevel {
  existingLevel: MembershipLevel;
  pendingLevel?: MembershipLevel;
  effectiveDate?: string;
}

export interface MSSProduct {
  type: MembershipProductType;
  status: MSSProductStatus;
  effectiveDate?: string;
}

export enum MSSProductStatus {
  EXISTING = 'EXISTING',
  ALLOWED = 'ALLOWED',
  NOT_ALLOWED = 'NOT_ALLOWED',
  INCLUDED = 'INCLUDED',
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
}

interface MSSProductRules {
  canAdd?: boolean;
  canRemove?: boolean;
  allowedBenefitLevels?: MembershipLevel[];
  waitPeriod?: number;
}

export interface BillPlanDetails {
  existingBillPlan: CurrentPayPlan;
  allowedBillPlans: CurrentPayPlan[];
}

export interface AutoPayDetails {
  accountLast4: string;
  cardType: string;
  cardExpirationDate: string;
}

enum MSSProductType {
  RV = 'RV',
}

export enum MemberSuffix {
  SR = 'Sr.',
  JR = 'Jr.',
  II = 'II',
  III = 'III',
  IV = 'IV',
  DDS = 'DDS',
  PHD = 'PHD',
  ESQ = 'ESQ',
}

export enum GenderCode {
  M = 'M',
  F = 'F',
  X = 'X',
}

export interface MSSEnrollment {
  type: MSSEnrollmentType;
  hasEnrollment: boolean;
}

export enum MSSEnrollmentType {
  PAPERLESS = 'PAPERLESS',
  ID_THEFT = 'ID_THEFT',
}

export interface MSSMembers {
  roleCode?: string;
  roleType: RoleType;
  nameTitle?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  nameSuffix?: string;
  gender?: GenderType;
  dateOfBirth?: string | null;
  residenceAddress?: MemberAddress;
  mailingAddress?: MemberAddress;
  emailAddress?: string;
  emailStatusCode?: string;
  mobilePhoneNumber?: string; // this will be removed and replaced with phoneNumbers/MSSPhone array
  phoneNumbers?: MSSPhone[];
  rules?: MSSMemberRules;
  status: MSSMemberStatus;
  customerId?: string;
  membershipCardNumber?: string;
  joinYear?: string | undefined;
  virtualId?: string;
  secured?: boolean;
  spinOffStatus?: MSSSpinOffStatus;
}

export interface MSSPhone extends MemberPhone {
  mobileAuthStatus: MSSMobileAuthStatus;
  isMobilePhone?: boolean;
}

export enum MSSSpinOffStatus {
  SPIN_OFF = 'SPIN_OFF',
  SPIN_UP = 'SPIN_UP',
  NONE = 'NONE',
}

export enum MSSMobileAuthStatus {
  CONSENTED = 'CONSENTED',
  NOT_CONSENTED = 'NOT_CONSENTED',
  NOT_RESPONDED = 'NOT_RESPONDED',
}

export interface MSSMemberRules {
  viewMembership: boolean;
  changeMembership: boolean;
  makePayment: boolean;
  updateEmail: boolean;
  updatePhone: boolean;
  nameChange: MSSNameChangeRules;
}

export interface MSSNameChangeRules {
  firstName: boolean;
  middleName: boolean;
  lastName: boolean;
  suffix: boolean;
}

export interface MSSSchedulePayment {
  allowed: boolean;
  startDate: string;
  endDate: string;
}

export interface MSSAutopayDiscount {
  allowed: boolean;
  amount: number;
}

export interface IPriceCart {
  items: PriceCartItem[] | undefined;
  savings: number | undefined;
  salesTax: number | undefined;
  total: number | undefined;
}

export interface IMonthlyPaymentInfo {
  dueDate: string;
  amountDue: number;
  isPastDue: boolean;
}

export interface MemberContactInfo {
  memberInfo: MaintainExistingCustomerMemberInfo;
  customerId: string;
  clubCode: string;
  email?: ExistingMemberEmail;
  phone?: MSSPhone[];
}
